module.exports = __webpack_public_path__ + "img/construction.d4eadf16.png";